import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
// import {
//   filterEmaDotcmsPageLinks,
//   isSiteEmbedded,
//   onClickEmaDotcmsPageLinks,
// } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

/**
 * The Error Page Component informs the user that the server returned an error.
 * It uses the {@link SearchBoxComponent}.
 *
 * @example
 * <ish-error-page></ish-error-page>
 */
@Component({
  selector: 'ish-error',
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorComponent implements AfterViewInit, OnInit {
  //constructor(private renderer: Renderer2, private el: ElementRef) {}
  constructor() {}
  ngAfterViewInit() {
    //filterEmaDotcmsPageLinks(this.el, this.renderer);
    //this.RemoveJSBackInEma();
  }
  ngOnInit() {
    //onClickEmaDotcmsPageLinks(this.el, this.renderer);
  }
  // RemoveJSBackInEma() {
  //   if (isSiteEmbedded()) {
  //     const anchorTags = this.el.nativeElement.querySelectorAll('a');
  //     if (anchorTags) {
  //       anchorTags.forEach((anchor: HTMLAnchorElement) => {
  //         const href = anchor.getAttribute('href');
  //         if (!href) return;
  //         if (href === 'javascript:history.back()') {
  //           const parentNode = this.renderer.parentNode(anchor);
  //           const superParentNode = this.renderer.parentNode(parentNode);
  //           if (superParentNode) {
  //             this.renderer.removeChild(superParentNode, parentNode);
  //           }
  //         }
  //       });
  //     }
  //   }
  // }
}
